import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import NKRHeader from "../Component/NKRHeader";
import NKRFooter from "../Component/NKRFooter";
const ExtraCurricularActivity = () => {
  useEffect(() => {
    document.title =
      "Extra Curricular Activity -  Gayatri International School";
  }, []);
  return (
    <>
      <NKRHeader />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Extra Curricular Activity</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/Nekhpur/Home">Home</Link>
            </li>
            <li>|</li>
            <li>Academic</li>
            <li>|</li>
            <li>Extra Curricular Activity</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-12 lagimg">
              <p>
                The school lays emphasis on developing the intrinsic talent of
                pupils in music, drama and art by organizing classes on a
                regular basis with the help of specialists.
              </p>

              <h6>DANCE</h6>
              <p>
                The natural affinity of pupils to explore the kinesthetic
                intelligence is further enhanced by providing ample
                opportunities to develop their interests. The students are
                exposed to both the Indian and the Western forms of dance.
              </p>

              <h6>MUSIC</h6>
              <p>
                The school has a well-equipped music room with a large
                collection of instruments. The students get opportunities to
                develop their musical intelligence by playing a range of
                instruments that suit their interests. The students are
                encouraged to explore both the Indian and the western music.
              </p>

              <h6>DRAMA</h6>
              <p>
                The school make a conscious attempt to develop the skills both
                in outside the class-room. The cultural functions held regularly
                provide forum to refine the skills with the help of experts.
              </p>

              <h6>SOF</h6>
              <p>
                We are thrilled to announce the outstanding achievements of our
                students at the recent SOF Olympiad. We take immense pride in
                sharing that our talented individuals secured 85 Gold medals and
                a large number of Silver and Bronze medals, bringing glory to
                Gayatri International School. Their dedication and hardwork
                truly shine, reflecting the school's commitment to academic
                excellence.
              </p>
            </div>
          </div>
        </div>
      </section>
      <NKRFooter />
    </>
  );
};

export default ExtraCurricularActivity;
